import { render, staticRenderFns } from "./DataClean.vue?vue&type=template&id=56f19179&scoped=true"
import script from "./DataClean.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataClean.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DataClean.vue?vue&type=style&index=0&id=56f19179&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f19179",
  null
  
)

export default component.exports